const COMMON_PREFIX = "SWIGGY_PLAN_BULLS_EYE_TG";

export const BULLS_EYE_TG = {
    NUDGE_WIDGET: `${COMMON_PREFIX}_NUDGE_WIDGET`,
    HALF_CARD: `${COMMON_PREFIX}_HALF_CARD`,
    TAGLINE: `${COMMON_PREFIX}_TAGLINE`,
    HALF_CARD_SUCCESS_CTA: `${COMMON_PREFIX}_HALF_CARD_CTA`,
    HALF_CARD_SKIP_CTA: `${COMMON_PREFIX}_HALF_CARD_SKIP_CTA`,
    MAKE_IT_FREE: `${COMMON_PREFIX}_MAKE_IT_FREE`,
};
